import React, { useState, useEffect, useCallback } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { requestForToken, onMessageListener } from './firebase.js';
import { ADMIN_DOMAIN } from '../constants';
import UIfx from 'uifx'
import bellAudio from '../assets/bell.mp3'

const Notification = () => {
  const [notification, setNotification] = useState({ title: '', body: '', url: '' });
  // const notify = () => toast(<ToastDisplay />);
  const notify = useCallback(() => {
    toast.custom((t) => (
    <div
      className={`${t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
    >
      <div className="flex flex-col  justify-around border-transparent rounded ">
        <button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = ADMIN_DOMAIN + notification.url;
          }}
          className=" w-full border-b-1 border-r-1 border-t-4 border-l-4	 rounded-md rounded-r-lg p-4  items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          بازکردن
        </button>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="w-full  border-b-1 border-r-1 border-t-4 border-l-4 rounded-md rounded-r-lg p-4  items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          بستن
        </button>

      </div>
      <div className="flex border-l border-gray-200">
       
      </div>
      <div className="flex-1 w-0 p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0 pt-0.5">
            <img
              className="h-10 w-10 rounded-full"
              src="open.png" // Use environment variable for the logo URL
              alt=""
            />
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-medium text-gray-900" style={{ 'white-space': 'pre-line' }}>
              {notification?.title}
            </p>
            <p className="mt-1 text-sm text-gray-500" style={{ 'white-space': 'pre-line' }}>
              {notification?.body}
            </p>
          </div>
        </div>
      </div>

    </div >


));
}, [notification]);


  // function ToastDisplay() {
  //   console.log("injaaaa ", notification)
  //   return (
  //     <div>
  //       <p><b>{notification?.title}</b></p>
  //       <p>{notification?.body}</p>
  //     </div>
  //   );
  // };

  useEffect(() => {
    if (notification?.title) {
      notify()
    }
  }, [notification,notify])

  requestForToken();

  onMessageListener()
    .then((payload) => {
      console.log("inja notif amad")
      const bell = new UIfx(
        bellAudio,
        {
          volume: 0.4, // number between 0.0 ~ 1.0
          throttleMs: 100
        }
      )
      bell.play()
      setNotification({ title: payload?.data?.title, body: payload?.data?.body, url: payload?.data?.url });
    })
    .catch((err) => console.log('failed: ', err));

  return (
    <Toaster toastOptions={{
      // Define default options
      className: '',
      duration: 3000000,
      style: {
        background: '#3c0e0e',
        color: '#fff',
      }
    }}
    />
  )
}

export default Notification